export class AuditableEntity {

    constructor(_CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date,
        _DeletedBy?: string, _DeletedDate?: Date) {

        this.CreatedBy = _CreatedBy;
        this.CreatedDate = _CreatedDate;
        this.UpdatedBy = _UpdatedBy;
        this.UpdatedDate = _UpdatedDate;
        this.DeletedBy = _DeletedBy;
        this.DeletedDate = _DeletedDate;

    }

    public CreatedBy: string;
    public CreatedDate: Date;
    public UpdatedBy: string;
    public UpdatedDate: Date;
    public DeletedBy: string;
    public DeletedDate: Date;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/audible-entity.model.ts